import { useContext } from 'react'
import { BrowserRouter } from 'react-router'
import { UserContext } from './contexts/userContext'
import Splash from './routes/splash'
import Dashboard from './routes/dashboard'

const App = () => {

  const { user } = useContext(UserContext)

  return (
    <>
      {user?.emailVerified ?
        <BrowserRouter>
          <Dashboard />
        </BrowserRouter> :
        <Splash />
      }
    </>
  )
}

export default App